// @flow

import { useController } from 'react-hook-form';
import { View } from 'reshaped';
import type { TextFieldProps } from 'reshaped';

import { Button } from '@gandi/reshaped';

import { FieldWrapper } from './FieldWrapper';
import type { FieldProps } from './types';

export type Props = {
  ...FieldProps<TextFieldProps>,
  size?: 'small' | 'medium' | 'large',
  isReadOnly?: boolean,
  values?: Array<{ value: string, label: string }>,
};

export function PillsField({
  name,
  label,
  help,
  disabled,
  control,
  rules,
  onChange,
  inputProps,
  inputAttributes,
  size,
  isReadOnly,
  values,
  ...extraProps
}: Props): React.MixedElement | null {
  const { field, fieldState } = useController({
    name,
    control,
    rules,
  });

  if (!values?.length) return null;

  return (
    <FieldWrapper
      fieldState={fieldState}
      label={label}
      help={help}
      {...extraProps}
    >
      <View gap={3} direction="row" paddingBlock={1}>
        {values.map(item => {
          const isSelected = field.value === item.value;

          if (!isReadOnly) {
            return (
              <Button
                rounded
                key={item.value}
                color={isSelected ? 'primary' : undefined}
                variant={isSelected ? 'solid' : 'outline'}
                onClick={() => field.onChange(item.value)}
                size={size}
              >
                {item.label}
              </Button>
            );
          }
          if (isSelected) {
            return (
              <Button
                rounded
                key={item.value}
                color={isSelected ? 'primary' : undefined}
                variant={isSelected ? 'solid' : 'outline'}
                onClick={() => field.onChange(item.value)}
                size={size}
              >
                {item.label}
              </Button>
            );
          }

          return null;
        })}
      </View>
    </FieldWrapper>
  );
}
